import { lazy, Suspense } from "react";
import { Skeleton } from "@/components/ui/skeleton";

// Prescreen detail lives on its own route (/qa/prescreen/:id) and is a SEPARATE
// page from the normal Delivery QA detail (qa-detail.tsx → qa-detail-v3). They
// must stay separate — see ~/Productivity/PreScreening for the rationale.
const PrescreenDetailV3 = lazy(() => import("./prescreen-detail-v3"));

export default function PrescreenDetail() {
  return (
    <Suspense
      fallback={
        <div className="flex items-center justify-center h-full">
          <Skeleton className="h-8 w-48" />
        </div>
      }
    >
      <PrescreenDetailV3 />
    </Suspense>
  );
}
